module.exports = __webpack_public_path__ + "img/vip-coupon-ratio.48f5771a.png";